import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import { useFetchQuery } from "src/graphql/utils";
import { mapToOperator } from "src/mappers/operator.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

import { RuleOperatorsQuery, RuleOperatorsQueryVariables } from "../../__generated__/graphql";
import { operatorFragment } from "../../fragments/OperatorFragment";

const ruleOperatorsQuery = gql`
  query ruleOperators($dataType: DataType!) {
    allowedCasePropertyRuleOperators(dataType: $dataType) {
      ...OperatorFragment
    }
  }
  ${operatorFragment}
` as TypedDocumentNode<RuleOperatorsQuery, RuleOperatorsQueryVariables>;

export const useGetRuleOperatorsQuery = (
  options?: QueryHookOptions<RuleOperatorsQuery, RuleOperatorsQueryVariables>
) => {
  return useFetchQuery(ruleOperatorsQuery, {
    queryOptions: options,
    toData: (data) => data?.allowedCasePropertyRuleOperators?.map(mapToOperator) ?? [],
    isEmpty: (data) => isEmpty(data?.allowedCasePropertyRuleOperators),
    uiErrors: {
      fetchError: "FETCH-OPERATORS-ERROR",
      emptyError: "EMPTY-OPERATORS-ERROR",
    },
  });
};
